import { LogicNodeDefinition } from '../LogicNodeDefinition';

export const FalseNode: LogicNodeDefinition = {
  type: 'FALSE',
  createDefaultState: () => null,
  process: () => false,
};
